// extracted by mini-css-extract-plugin
var _1 = "styles-module__accordionContainer___BH34d";
var _2 = "styles-module__accordionExtended___wVT8W";
var _3 = "styles-module__hidePanel___RbX83";
var _4 = "styles-module__panel___baShW";
var _5 = "styles-module__panelBottom___jWnlr";
var _6 = "styles-module__panelJib___i4nrg";
var _7 = "styles-module__panelSpacer___BbdCh";
export { _1 as "accordionContainer", _2 as "accordionExtended", _3 as "hidePanel", _4 as "panel", _5 as "panelBottom", _6 as "panelJib", _7 as "panelSpacer" }
